import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ArtworkCard from '@/components/ArtworkCard';
import { useAuth } from '@/context/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function FavoritesPage() {
  const { getAuthHeaders } = useAuth();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFavorites();
  }, []);

  const fetchFavorites = async () => {
    try {
      const response = await axios.get(`${API}/favorites`, getAuthHeaders());
      setFavorites(response.data);
    } catch (error) {
      console.error('Failed to fetch favorites:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-32 pb-24" data-testid="favorites-page">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <h1 className="font-serif text-4xl md:text-5xl tracking-tight mb-12" data-testid="favorites-title">
          My Favorites
        </h1>

        {loading ? (
          <div className="text-center text-muted-foreground py-20">Loading favorites...</div>
        ) : favorites.length === 0 ? (
          <div className="text-center py-20">
            <Heart className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground mb-6" data-testid="no-favorites-message">
              You haven't added any favorites yet
            </p>
            <Link to="/gallery">
              <Button className="rounded-full" data-testid="browse-gallery-btn">
                BROWSE GALLERY
              </Button>
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16" data-testid="favorites-grid">
            {favorites.map((artwork) => (
              <ArtworkCard key={artwork.id} artwork={artwork} onFavoriteChange={fetchFavorites} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}